<template>
  <div class="list-user">
    <div class="list-user-table">
      <div class="mb-2 row">
        <h2
          class="col-sm-12 col-md-6 col-lg-6 text-truncate-mess font-title font-weight-bold"
        >
          売上管理（月別）
        </h2>
        <div
          class="px-0 col-sm-12 col-md-6 col-lg-6 tex-left text-md-right text-sm-left"
        >
          <router-link
            :to="{
              name: $route.params.shopId
                ? 'listSaleManagementRanks'
                : 'listSaleManagementRanks domain',
            }"
          >
            <button class="mr-2 button-create-user bg-00b797">
              ランキング
            </button>
          </router-link>
          <button class="button-create-user bg-00b797" @click="downloadCSV()">
            CSV出力
          </button>
          <button
            v-on:click="gotoDashboard()"
            class="button-back-dashboard back-btn"
          >
            戻る
          </button>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-12 font-weight-bold pl-3">期間絞り込み</label>
        <div class="row-input col-sm-4 col-md-4 mb-3 mb-sm-0 col-lg-3">
          <date-picker
            class="w-100"
            v-model="month_from"
            type="month"
            locale="ja"
            valueType="YYYY-MM"
            @change="dateSelectedDateFrom"
          ></date-picker>
        </div>
        <span
          class="col-auto custom-span text-center p-0 justify-content-center"
          style="line-height: 25px"
          >~</span
        >
        <div class="row-input col-sm-4 col-md-4 mb-3 mb-sm-0 col-lg-3">
          <!-- <CInput type="date" v-model="created_to" max="9999-12-31" /> -->
          <div class="fd-admin-listproperty-card-filter filter-date">
            <date-picker
              class="w-100"
              v-model="month_to"
              type="month"
              locale="ja"
              valueType="YYYY-MM"
              @change="dateSelectedDateTo"
            ></date-picker>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-4 mb-4">
        <b-button
          v-on:click.prevent="getlistSaleManagementMonthlys()"
          variant="info"
          class="mr-4"
          >絞り込み検索</b-button
        >
        <b-button
          variant="secondary"
          class="mr-4"
          v-on:click="resetFieldSearch()"
          >リセット</b-button
        >
      </div>
      <div class="row position-relative">
        <div class="col-sm-12 col-md-6 col-lg-3">
          <p class="font-weight-bold">
            {{ yearfrom }}年{{ monthfrom }}月 ～ {{ yearto }}年{{ monthto }}月
          </p>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-auto">
          <p class="font-weight-bold">総計：{{ total }}円</p>
        </div>
      </div>
      <Tables
        :items="listSaleManagementMonthly.data"
        :fields="fields"
        :itemsPerPageSelect="{}"
      >
        <template v-slot:page_content="{ item }">
          <td v-html="item.page_content"></td>
        </template>
        <template v-slot:id="{ index }">
          <td>{{ index + 1 }}</td>
        </template>
        <template v-slot:status_order="{ item }">
          <td v-if="item.status_order == 0">未承認</td>
          <td v-else-if="item.status_order == 1">承認済み</td>
          <td v-else-if="item.status_order == 2">キャンセル</td>
        </template>
        <template v-slot:created_at="{ item }">
          <td>
            {{
              new Date(item.created_at).toLocaleString("ja-JP", {
                timeZone: "Asia/Tokyo",
              })
            }}
          </td>
        </template>
        <template v-slot:logout_at="{ item }">
          <td>
            {{
              new Date(item.logout_at).toLocaleString("ja-JP", {
                timeZone: "Asia/Tokyo",
              })
            }}
          </td>
        </template>
        <template v-slot:total_quantity="{ item }">
          <td>
            {{ Number(item.total_quantity).toLocaleString("ja") }}
          </td>
        </template>
        <template v-slot:total_revenue="{ item }">
          <td>
            {{ Number(item.total_revenue).toLocaleString("ja") }}
          </td>
        </template>
        <template v-slot:action="{ item }">
          <td class="py-2 pl-2 pr-1 d-flex justify-content-center">
            <div>
              <CButton
                class="mx-1 btn-other"
                v-on:click="detail(item.month)"
                color="primary"
                square
                variant="outline"
                size="sm"
                v-b-modal.modal-comfirm
              >
                日別詳細
              </CButton>
            </div>
          </td>
        </template>
      </Tables>
      <div
        class="d-flex justify-content-center position-relative"
        v-if="listSaleManagementMonthly.total"
      >
        <p class="font-weight-bold">
          {{ listSaleManagementMonthly.total }}件中{{
            listSaleManagementMonthly.data.length
          }}件を表示
        </p>
      </div>
      <div
        class="d-flex justify-content-center position-relative"
        v-if="listSaleManagementMonthly.last_page"
      >
        <CPagination
          v-if="listSaleManagementMonthly.total"
          :activePage.sync="page"
          :pages="listSaleManagementMonthly.last_page"
          align="center"
        />
        <!-- <div class="custom-selectLimitPage">
          <b-form-select
            v-model="limit"
            tag-placeholder="Add this as new category"
            :options="listLimitRecordPage"
            @change="changeLimitPage()"
          ></b-form-select>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Tables from "../../components/common/Tables";
import { tableFields } from "../../utils/table-fields.js";
import { mapActions, mapGetters } from "vuex";
import Encoding from "encoding-japanese";
import { Urls } from "../../utils/urls.js";
import { Api } from "../../utils/http-common.js";
import { Constants } from "../../utils/constants";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ja";
DatePicker.locale("ja");
// import $ from "jquery";
export default {
  name: "listSaleManagementMonthlys",
  data() {
    return {
      fields: tableFields.SALE_MANAGEMENT_MONTHLY,
      listLimitRecordPage: [
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 200, text: "200" },
      ],
      dataModal: "",
      total_amount: "",
      title: "",
      name: "",
      status_order: "",
      month_from: "",
      month_to: "",
      limit: 50,
      page: 1,
      messageError: {},
      messageResponse: "",
      messagerErr: "",
      messageSuccess: "",
      lang: "ja",
      monthfrom: "",
      monthto: "",
      yearfrom: "",
      yearto: "",
      total_revenue: "",
      total: "",
      shop_id: localStorage.getItem(Constants.SHOP_ID),
    };
  },
  components: {
    Tables,
    DatePicker,
  },
  created() {
    this.getlistSaleManagementMonthlys(1);
  },
  computed: {
    ...mapGetters([
      "listSaleManagementMonthly",
      "dataSumSaleManagementMonthly",
      "message",
      "success",
      "error",
    ]),
  },
  watch: {
    success() {
      if (this.success) {
        this.$toasted.success(this.message);
        this.$store.commit("set", ["message", ""]);
        this.$store.commit("set", ["success", false]);
      }
    },
    error() {
      if (this.error) {
        this.$toasted.error(this.message);
        this.$store.commit("set", ["message", ""]);
        this.$store.commit("set", ["error", false]);
      }
    },
    listSaleManagementMonthly() {
      this.json_data = this.listSaleManagementMonthly.data;
      this.page = this.listSaleManagementMonthly.current_page;
    },
    page() {
      this.getlistSaleManagementMonthlys(this.page);
    },
    dataSumSaleManagementMonthly() {
      if (this.dataSumSaleManagementMonthly[0] !== null) {
        const dateStartDefault =
          this.dataSumSaleManagementMonthly[0].month_start.split("-");
        this.yearfrom = dateStartDefault[0];
        this.monthfrom = dateStartDefault[1];
        const dateEndDefault =
          this.dataSumSaleManagementMonthly[0].month_end.split("-");
        this.yearto = dateEndDefault[0];
        this.monthto = dateEndDefault[1];
        this.total = Number(
          this.dataSumSaleManagementMonthly[0].total
        ).toLocaleString("ja");
      }
    },
  },
  methods: {
    ...mapActions({ getSaleManagetmentMonthly: "getSaleManagetmentMonthly" }),
    ...mapActions({
      getSumSaleManagetmentMonthly: "getSumSaleManagetmentMonthly",
    }),
    changeLang() {
      this.lang === "ja";
    },
    getlistSaleManagementMonthlys(page) {
      if (page === undefined) {
        page = this.page;
      }
      const formData = {
        page: page,
        data: {
          shop_id: this.shop_id,
          limit: this.limit,
          month_from: this.month_from,
          month_to: this.month_to,
        },
      };
      this.getSaleManagetmentMonthly(formData);
      const dataSum = {
        shop_id: this.shop_id,
        month_from: this.month_from,
        month_to: this.month_to,
      };
      this.getSumSaleManagetmentMonthly(dataSum);
    },
    changeLimitPage() {
      this.getlistSaleManagementMonthlys(1);
    },
    async csvExport(datas, dataRequest) {
      const url = `${Urls.ADMIN}/${Urls.SALES_MANAGEMENT}/${Urls.MONTHLY}/${Urls.EXPORT}`;
      const method = "POST";
      let response = await Api.adminRequestServer({
        method,
        url,
        data: dataRequest,
      });
      var { data } = response.data;
      if (data.success === false) return datas;
      datas += data.data;
      this.index++;
      if (this.index % Constants.LIMIT_CSV == 0) {
        const getDate = new Date();
        const nameExcel =
          "売上管理（月別）" +
          [
            getDate.getFullYear(),
            getDate.getMonth() + 1,
            getDate.getDate(),
          ].join("_") +
          " " +
          [getDate.getHours(), getDate.getMinutes(), getDate.getSeconds()].join(
            ":"
          );
        const CSVName = nameExcel + ".csv";
        let file = "対象月,販売件数,売上総計（円）\n";
        file += datas;
        datas = [];
        file = new Encoding.stringToCode(file);
        file = Encoding.convert(file, "sjis", "unicode");
        file = new Uint8Array(file);
        var fileURL = window.URL.createObjectURL(
          new Blob([file], { type: "text/csv;charset=sjis" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", CSVName);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
      // if (data.data.status == "未承認") {
      //   dataRequest.id = data.data.id;
      //   datas = await this.csvExport(datas, dataRequest);
      //   return datas;
      // }
      return datas;
    },
    async downloadCSV() {
      this.messageError = {};
      this.messageResponse = "";
      this.messagerErr = "";

      try {
        this.index = 0;
        var datas = [];
        let dataRequest = {
          id: 0,
          shop_id: this.shop_id,
          month_from: this.month_from,
          month_to: this.month_to,
        };
        datas = await this.csvExport(datas, dataRequest);
        if (Object.keys(datas).length == 0) {
          if (this.index == 0) {
            this.messageResponse = "データがありません";
          } else {
            this.messageSuccess = "ダウンロードが完了しました";
          }
          // $("body").removeClass("wait");
          return;
        }
        const getDate = new Date();
        const nameExcel =
          "売上管理（月別）" +
          [
            getDate.getFullYear(),
            getDate.getMonth() + 1,
            getDate.getDate(),
          ].join("_") +
          " " +
          [getDate.getHours(), getDate.getMinutes(), getDate.getSeconds()].join(
            ":"
          );
        const CSVName = nameExcel + ".csv";
        dataRequest.month_from.replaceAll("-", "") +
          "-" +
          dataRequest.month_to.replaceAll("-", "") +
          "_" +
          (Math.floor(this.index / Constants.LIMIT_CSV) + 1) +
          ".csv";
        let file = "対象月,販売件数,売上総計（円）\n";
        file += datas;
        file = new Encoding.stringToCode(file);
        file = Encoding.convert(file, "sjis", "unicode");
        file = new Uint8Array(file);
        var fileURL = window.URL.createObjectURL(
          new Blob([file], { type: "text/csv;charset=sjis" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", CSVName);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.messageSuccess = "ダウンロードが完了しました";
        // $("body").removeClass("wait");
      } catch (e) {
        // $("body").removeClass("wait");
        this.messageResponse = "システムエラーが発生しました";
        console.log(e);
      }
    },
    gotoDashboard() {
      this.$router.go(-1);
    },
    dateSelectedDateFrom() {
      if (this.month_from !== null) {
        const dateForm = this.month_from.split("-");
        this.yearfrom = dateForm[0];
        this.monthfrom = dateForm[1];
      }
    },
    dateSelectedDateTo() {
      if (this.month_to !== null) {
        const dateForm = this.month_to.split("-");
        this.yearto = dateForm[0];
        this.monthto = dateForm[1];
      }
    },
    resetFieldSearch() {
      this.month_from = "";
      this.month_to = "";
      const formData = {
        page: 1,
        data: {
          shop_id: this.shop_id,
          limit: this.limit,
          month_from: this.month_from,
          month_to: this.month_to,
        },
      };
      this.getSaleManagetmentMonthly(formData);
      const dataSum = {
        shop_id: this.shop_id,
        month_from: this.month_from,
        month_to: this.month_to,
      };
      this.getSumSaleManagetmentMonthly(dataSum);
    },
    detail(month) {
      if (this.$route.params.shopId) {
        this.$router.push({
          name: "saleManagementdaily",
          params: { shopId: this.shop_id, daily: month },
        });
      } else {
        this.$router.push({
          name: "saleManagementdaily domain",
          params: { daily: month },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-span {
  @media (max-width: 420px) {
    display: none;
  }
}
</style>
